import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Check } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t bg-background py-12">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-9 h-9 bg-primary rounded-lg flex items-center justify-center relative shadow-sm">
                <CheckCircle className="w-5 h-5 text-primary-foreground" />
                <div className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-green-500 rounded-full flex items-center justify-center border-2 border-background">
                  <Check className="w-2 h-2 text-white" />
                </div>
              </div>
              <span className="text-xl font-bold text-foreground tracking-tight">
                LLMChecks
              </span>
            </div>
            <p className="text-muted-foreground text-sm">
              Empowering AI safety and reliability through comprehensive model
              validation.
            </p>
          </div>
          {/* Product Links */}
          <div>
            <h4 className="font-semibold mb-4 text-foreground">Product</h4>
            <nav className="space-y-2">
              <Link to="/product/features" className="block text-muted-foreground hover:text-foreground text-sm">Features</Link>
              <Link to="/product/api" className="block text-muted-foreground hover:text-foreground text-sm">API</Link>
            </nav>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-4">Company</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link
                  to="/company/about"
                  className="hover:text-foreground transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="hover:text-foreground transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/company/careers"
                  className="hover:text-foreground transition-colors"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  to="/company/contact"
                  className="hover:text-foreground transition-colors"
                >
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-4">Legal</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link
                  to="/legal/privacy"
                  className="hover:text-foreground transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/terms"
                  className="hover:text-foreground transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/security"
                  className="hover:text-foreground transition-colors"
                >
                  Security
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t mt-8 pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            © 2025 LLMChecks. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
